export type AuthMedium = 'facebook' | 'apple' | 'email' | (string & {});

export type UserState = GuestUserState | LoggedInUserState;

export interface OptionalUserState {
  userData: LoggedInUserData | null;
}

export interface GuestUserState {
  guestToken?: string;
}

export interface LoggedInUserState {
  token: string;
}

export interface LoggedInUserData {
  id: number;
  gender: Exclude<UserGenders, UserGenders.Kids>;
  email: string;
  firstName?: string;
  lastName?: string;
  phone?: string;
  birthday?: string;
  isExistingCustomer: boolean;
  emailHash: EmailHash;
  loginType?: AuthMedium;
}

export enum UserGenders {
  Male = 'male',
  Female = 'female',
  Kids = 'kids',
}

interface EmailHash {
  emh: string;
  emhec?: string;
}
